import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import { FlyoutControlled } from './FlyoutControlled';
const FlyoutUncontrolledRoot = (props, ref) => {
    const { defaultActive, onClose, onOpen, closeOnScroll } = props;
    const [active, setActive] = React.useState(defaultActive || false);
    const handleClose = () => {
        setActive(false);
        if (onClose)
            onClose();
        closeOnScroll && (document === null || document === void 0 ? void 0 : document.removeEventListener('scroll', handleClose, true));
    };
    const handleOpen = () => {
        setActive(true);
        if (onOpen)
            onOpen();
        closeOnScroll && (document === null || document === void 0 ? void 0 : document.addEventListener('scroll', handleClose, true));
    };
    return (_jsx(FlyoutControlled, Object.assign({}, props, { ref: ref, defaultActive: undefined, active: active, onClose: handleClose, onOpen: handleOpen })));
};
export const FlyoutUncontrolled = React.forwardRef(FlyoutUncontrolledRoot);
